/** Shared interpretation of Bókun transfer requirements; no title/hotel inference. */
export function bookingTransferRequirements(product: Record<string, unknown>) {
  const requiredQuestion = (key: string, prefix: string) => {
    const lists = [product[key], product.bookingQuestions];
    return lists.some((list) => Array.isArray(list) && list.some((value) => {
      if (!value || typeof value !== "object") return false;
      const question = value as Record<string, unknown>;
      const id = String(question.questionId ?? question.id ?? "");
      return question.required === true &&
        (id.startsWith(prefix) || list === product[key]);
    }));
  };
  const pickupRequired = String(product.meetingType ?? "").toUpperCase() === "PICK_UP" ||
    product.pickupRequired === true || requiredQuestion("pickupQuestions", "pickupPlace");
  // A return service asks for its destination independently of meetingType.
  const dropoffRequired = product.dropoffService === true || product.dropoffRequired === true ||
    requiredQuestion("dropoffQuestions", "dropoffPlace");
  return {
    pickupRequired,
    dropoffRequired,
    pickupAvailable: pickupRequired || product.pickupService === true || product.pickupAvailable === true ||
      (Array.isArray(product.pickupPlaces) && product.pickupPlaces.length > 0),
    dropoffAvailable: dropoffRequired,
  };
}

export function missingBookingTransfers(
  requirements: { pickupRequired?: boolean; dropoffRequired?: boolean },
  values: { pickupPlaceId?: string | null; pickupNote?: string | null; dropoffPlaceId?: string | null; dropoffNote?: string | null },
): Array<"pickup" | "dropoff"> {
  const missing: Array<"pickup" | "dropoff"> = [];
  if (requirements.pickupRequired && !values.pickupPlaceId?.trim() && !values.pickupNote?.trim()) missing.push("pickup");
  if (requirements.dropoffRequired && !values.dropoffPlaceId?.trim() && !values.dropoffNote?.trim()) missing.push("dropoff");
  return missing;
}